import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './appInfo';
import './torah-font.css';
//Import Mixpanel SDK
import mixpanel from 'mixpanel-browser';

let zoomHandlersAttached = false;

const disableBrowserZoom = () => {
  if (zoomHandlersAttached) return;

  const handleWheel = (event: WheelEvent) => {
    if (event.ctrlKey || event.metaKey) {
      event.preventDefault();
    }
  };

  const handleKeyDown = (event: KeyboardEvent) => {
    if ((event.ctrlKey || event.metaKey) && ['+', '-', '=', '0'].includes(event.key)) {
      event.preventDefault();
    }
  };

  const handleTouchMove = (event: TouchEvent) => {
    if (event.touches.length > 1) {
      event.preventDefault();
    }
  };

  window.addEventListener('wheel', handleWheel, { passive: false });
  window.addEventListener('keydown', handleKeyDown, { passive: false });
  window.addEventListener('touchmove', handleTouchMove, { passive: false });

  zoomHandlersAttached = true;
};

disableBrowserZoom();

// Create an instance of the Mixpanel object, your token is already added to this snippet
mixpanel.init('8ace1531ce8c2e5e52e76dd08a941f33', {
  autocapture: true,
  record_sessions_percent: 100,
  record_mask_text_selector: '',
});
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
